import { BrandVariants, Theme, createDarkTheme, createLightTheme } from '@fluentui/react-components';

// Custom brand colors based on --color-primary-500 (#ff5730)
const myNewTheme: BrandVariants = {
    10: '#1a0501',  // Darkest
    20: '#4d0f08',
    30: '#80190a',
    40: '#99250a',
    50: '#b33113',
    60: '#cc3e1c',
    70: '#e64a26',
    80: '#ff5730',  // Primary color (--color-primary-500)
    90: '#ff6b48',
    100: '#ff7f60',
    110: '#ff9379',
    120: '#ffa791',
    130: '#ffbbaa',
    140: '#ffcfc2',
    150: '#ffe3db',
    160: '#fff5f3',  // Lightest
};

const fontFamilyBase = "'Inter', ui-sans-serif, system-ui, sans-serif";
document.body.style.setProperty('--DefaultFontFamily', fontFamilyBase);

export const lightTheme: Theme = {
    ...createLightTheme(myNewTheme),
    fontFamilyBase,
};

export const darkTheme: Theme = {
    ...createDarkTheme(myNewTheme),
    fontFamilyBase,
};

darkTheme.colorBrandForeground1 = myNewTheme[110];
darkTheme.colorBrandForeground2 = myNewTheme[120];

darkTheme.colorNeutralBackground1 = '#18181b'; // Using zinc-900 color for dark background
darkTheme.colorNeutralBackgroundInverted = '#f1f1f1';

lightTheme.colorNeutralBackground5 = '#d9d9e3';
darkTheme.colorNeutralBackground5 = '#d9d9e3';

// Custom card background colors
(lightTheme as Theme & Record<string, string>).colorCardBackground1 = '#FFFFFF'; // White background for light mode
(darkTheme as Theme & Record<string, string>).colorCardBackground1 = 'var(--Colors-Zinc-800, #27272A)'; // Zinc-800 for dark mode

darkTheme.colorNeutralForegroundOnBrand= '#3D3D3D';
darkTheme.colorNeutralForeground2BrandHover= '#FF6542';

lightTheme.colorBrandBackgroundSelected= '#FF6542';
darkTheme.colorBrandBackgroundSelected= '#FF6542';